/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Player_SpeedInputs */

const en_mobile_player_speed = /** @type {(inputs: Mobile_Player_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_mobile_player_speed = /** @type {(inputs: Mobile_Player_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Mobile_Player_SpeedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_player_speed = /** @type {((inputs?: Mobile_Player_SpeedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Player_SpeedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_player_speed(inputs)
	return en_mobile_player_speed(inputs)
});